<template>
  <AppView :title="app" :backable="true" :deskHeader="false" :footerShow="false" :orderPage="true">
    <div class="flex min-h-0 flex-1 flex-col">
      <div class="flex min-h-0 w-full flex-1 overflow-hidden bg-white desk:min-h-[calc(100vh-14rem)] desk:items-start desk:overflow-visible">
        <nav
          data-desktop-catalog-rail
          class="h-full w-[92px] flex-none overflow-y-auto overflow-x-hidden border-r border-gray-100 bg-gray-50 scrollbar-hide pc:w-[104px] desk:sticky desk:top-14 desk:h-auto desk:max-h-[calc(100vh-3.5rem)] desk:w-[220px]"
          aria-label="商品分類"
        >
          <Navigation class="h-full w-full" />
        </nav>

        <main class="relative h-full flex-grow overflow-hidden bg-white desk:h-auto desk:min-w-0 desk:overflow-visible" aria-label="商品列表">
          <ProductList />
        </main>
      </div>
      <AppFooter class="hidden flex-none desk:block" />
    </div>
  </AppView>
</template>

<script>
import Navigation from "@/components/product/Navigation.vue";
import ProductList from "@/components/product/List";
import AppFooter from "@/components/app/AppFooter.vue";

export default {
    components: { Navigation, ProductList, AppFooter },
    auth: false,

    head() {
        const categoryTitle = this.$route.query.title;
        const info = this.$store.getters["app/info"];
        const appName = info?.name || process.env.APP_NAME;
        const pageTitle = categoryTitle ? `${categoryTitle} | ${appName} - 澳門頂尖遊戲點數卡及手遊儲值平台` : `${appName} - 澳門頂尖遊戲點數卡及手遊儲值平台`;
        const url = `${process.env.APP_URL}${this.$route.fullPath}`;
        
        const cleanDescription = (info.description || "").replace(/(<([^>]+)>)/gi, "").substring(0, 150) + "...";

        return {
            title: pageTitle,
            link: [
                {
                    rel: "canonical",
                    href: url,
                },
            ],
            meta: [
                {
                    hid: "robots",
                    name: "robots",
                    content: "index, follow",
                },
                {
                    hid: "keywords",
                    name: "keywords",
                    content: categoryTitle ? `${info.keywords}, ${categoryTitle}` : info.keywords,
                },
                {
                    hid: "description",
                    name: "description",
                    content: cleanDescription,
                },
                {
                    hid: "og:type",
                    name: "og:type",
                    property: "og:type",
                    content: "website",
                },
                {
                    hid: "og:title",
                    name: "og:title",
                    property: "og:title",
                    content: pageTitle,
                },
                {
                    hid: "og:site_name",
                    name: "og:site_name",
                    property: "og:site_name",
                    content: appName,
                },
                {
                    hid: "og:url",
                    name: "og:url",
                    property: "og:url",
                    content: url,
                },
                {
                    hid: "og:description",
                    name: "og:description",
                    property: "og:description",
                    content: cleanDescription,
                },
                {
                    hid: "og:image",
                    name: "og:image",
                    property: "og:image",
                    content: `${process.env.APP_URL}/static/icon.png`,
                },
                {
                    hid: "twitter:card",
                    name: "twitter:card",
                    content: "summary_large_image",
                },
                {
                    hid: "twitter:title",
                    name: "twitter:title",
                    content: pageTitle,
                },
                {
                    hid: "twitter:description",
                    name: "twitter:description",
                    content: cleanDescription,
                },
            ],
            script: [
                {
                    type: "application/ld+json",
                    json: {
                        "@context": "https://schema.org",
                        "@type": "BreadcrumbList",
                        "itemListElement": [
                            {
                                "@type": "ListItem",
                                "position": 1,
                                "name": "首頁",
                                "item": process.env.APP_URL
                            },
                            {
                                "@type": "ListItem",
                                "position": 2,
                                "name": appName,
                                "item": url
                            }
                        ]
                    }
                }
            ],
        };
    },
    data() {
        return {
            // no need to store dynamic `app` as data here, use computed
        };
    },
    computed: {
        app() {
            return (
                this.$store.getters["app/info"]?.name || process.env.APP_NAME
            );
        },
    },
    methods: {
        scrollTo(type) {
            this.$nextTick(() => {
                // delay 1 tick to wait for DOM update
                setTimeout(() => {
                    const ele = document.querySelector(
                        `[aria-colindex="${type}"]`
                    );
                    if (ele) {
                        ele.scrollIntoView({
                            behavior: "smooth",
                            block: "start",
                            inline: "nearest",
                        });
                    }
                }, 100);
            });
        },
    },

    mounted() {
        const type = this.$route.query.type;
        if (!type) return;
        this.scrollTo(type);
    },
};
</script>

<style scoped></style>
